import React from 'react'
import Dropzone from 'react-dropzone'
import styled from 'styled-components'

import ProfilePicture from 'components/ProfilePicture'
import Button from 'components/Button'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

class ProfilePictureInput extends React.Component {
  render() {
    return (
      <Wrapper>
        <ProfilePicture src={this.props.value.preview} />
        <Dropzone
          ref={el => (this.dropzoneRef = el)}
          style={{ display: 'none' }}
          accept="image/*"
          multiple={false}
          onDrop={([profilePicture]) => this.props.onChange(profilePicture)}
        />
        <Button
          secondary
          type="button"
          onClick={e => {
            e.preventDefault()
            this.dropzoneRef.open()
          }}>
          Last opp bilde
        </Button>
      </Wrapper>
    )
  }
}

export default ProfilePictureInput



// WEBPACK FOOTER //
// ./src/components/form/ProfilePictureInput.js